import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import jobPostSlice from "./slices/jobPostSlice";
import userSlice from "./slices/userSlice";
import orderSlice from "./slices/orderSlice";
import payStackSlice from "./slices/payStackSlice";
import propertySlice from "./slices/propertySlice";
import notificationSlice from "./slices/notificationSlice";
import analyticsSlice from "./slices/analyticsSlice";
import paymentSlice from "./slices/paymentSlice";


const store = configureStore({
  reducer: {
    auth: authSlice,
    jobPost: jobPostSlice,
    user: userSlice,
    order: orderSlice,
    payStack: payStackSlice,
    property: propertySlice,
    notification: notificationSlice,
    analytics: analyticsSlice,
    payment: paymentSlice,

  },
});

export default store;

// INFO: Exporting auth actions and thunks
export {
  logout,
  switchRole,
  checkAndSwitchRoleByPath,
  openSignInModal, 
  closeSignInModal,
  handleSessionExpiration,
  endDataRefresh,
  startDataRefresh,
  updateAuth,
} from "./slices/authSlice";

export * from "./thunks/authThunks";
export * from "./thunks/jobPostThunks";
export * from "./thunks/userThunks";
export * from "./thunks/orderThunks";
export * from "./thunks/payStackThunks";
export * from "./thunks/threadThunks";
export * from "./thunks/propertyThunks"
export * from "./thunks/paymentThunks";
export * from "./thunks/supportRequestThunk";
export * from "./thunks/notificationThunks";
export * from "./thunks/analyticsThunks";
export * from "./thunks/paymentHistoryThunk";
